<template>
    <div>
        <div name="query-sort-block">
            <swb-query-sort-area ref="query_model_ctrl" :confKey="confKey" :configAuto="true" :queryOnLoad="true" :onConfigReady="onQueryConfigReady" :queryHandler="queryHandler"></swb-query-sort-area>
        </div>
        <div class="simple-row" name="btns">
            <div class="left">
                <div v-if="checkActionPerm('create')" class="swb-btn swb-btn-small" @click="toServcWorkReceiptAdd">
                    <span>新增</span>
                </div>
            </div>
            <div class="right">
                <div v-if="checkActionPerm('create_js')" class="swb-btn swb-btn-small swb-btn-primary" @click="toCreateJS(null)">
                    <span>生成结算单</span>
                </div>
                <a class="swb-btn swb-btn-small swb-btn-primary" @click="taskExport" v-if="checkActionPerm('task_export')">执行导出任务</a>
                <a class="swb-btn swb-btn-small swb-btn-primary" @click="viewTaskExport" v-if="checkActionPerm('view_task_export')">查看结果文件</a>
            </div>
        </div>
        <swb-result-table name="result_table" :btnColBaseCount="2" :btnColMoreTitle="'更多操作'" ref="result_table" :confKey="confKey" :configAuto="true" :needPager="needPager" :multiSelect="multiSelect" :multiPageSelect="multiPageSelect"
                          :rowKeyPropName="rowKeyPropName" :rowNoShow="rowNoShow" :rowNoFixed="rowNoFixed" :btnColName="btnColName" :btnColTitle="btnColTitle" :btnColWidth="btnColWidth" :btnColFixed="btnColFixed" :height="theTableHeight"
                          :pageNoChangeHandler="pageNoChangeHandler"></swb-result-table>
    </div>
</template>

<script>
    import {$, Utils} from '../../app.base'
    import {DomSizeWatcher, MsgBox, Vue} from '../../app.vues'
    import {getDefaultPageSizes} from '../../app.conf'
    import {checkUserActionPerm} from '../index';
    import {openServcWorkReceiptConfirmDlg, openServcWorkReceiptDetailDlg, openServcWorkReceiptSaveDlg, openServcWorkSettleProofSaveDlg} from './showDlg';
    import {createTaskExportDlg, viewTaskExportListDlg} from '../devc/selectDlg'
    import {showComActionPostSelectDlg} from '../merchant/showSelectDlg'
    import {openApplyDescDlg, openAuditDlg} from '../bizUnion/selectDlg'

    import receiptApi from '../../api/receipt';
    import comnApi from '../../api/comn';
    import userApi from '../../api/user';
    import settleApi from '../../api/settle';

    export default {
        name: 'swb-servc-work-receipt-list',
        path: '/servc/work/receipt/list/get',
        desc: '工单验收单管理',
        data: function () {
            return {
                // 分页信息
                pageNumber: 1,
                totalCount: 0,
                pageSize: null,
                pageSizes: getDefaultPageSizes(),
                //
                confKey: 'swb-servc-work-receipt-list',
                theTableHeight: 300,
                //
                needPager: true, //是否需要分页（默认：true）
                multiSelect: true, //是否多选（默认：false）
                multiPageSelect: true, //是否要多页/跨页选择（默认：false）
                rowKeyPropName: 'id', //记录数据关键标识列名（多页/跨页选择必须，默认: id）
                rowNoShow: false, //是否显示行号（默认：true）
                rowNoFixed: false, //行号列是否固定（默认：false）
                //
                btnColName: 'actions',//操作列名称（如果不设置就不显示操作列）
                btnColTitle: '操作',//操作列标题（默认：'操作'）
                btnColWidth: 180,//操作列宽度（默认：100）
                btnColFixed: true, //操作列是否固定
                // 过滤信息
                queryKey: null,
                queryModel: {
                    filterItems: {},
                    sortItemList: [],
                    sortItems: {}
                },
                exportFilter: {},
                // 其他信息
                receiptList: [],
                scopeEntity: {},
                settleStateMpas: getEnumMap('settleState', 'value2text'),
                ledgerStateMap: getEnumMap('ledgerState', 'value2text'),
                innerNo: null,
                isAuditBpConfAvailable: false,
                needAssignAuditors: false
            }
        },
        created: function () {
            this.pageSize = this.pageSizes.first();
            let routeQuery = this.$getRouteQuery();
            this.innerNo = routeQuery.innerNo || null;
            this.getCurrentUserInfo();
        },
        mounted() {
            let self = this;
            //注册domSizeWatcher
            let thisEl = $(this.$el);
            $(this.$el).addClass('overflow-hidden');
            //
            let domSizeWatcher = this.domSizeWatcher = new DomSizeWatcher(Vue.$getClassInfo(this).name);
            domSizeWatcher.setBaseEl(thisEl);
            domSizeWatcher.setMainEl(thisEl.find('[name="result_table"]'), function (width, height, theEl) {
                //根据新主元素的内容大小，调整表格高度
                self.theTableHeight = height;
            });
            //domSizeWatcher.setHrEls();
            domSizeWatcher.setVtEls(thisEl.find('[name="query-sort-block"], [name="btns"]'));
            domSizeWatcher.start(500);
            //
            this.initResultTable();
        },
        destroyed() {
            //释放domSizeWatcher
            let domSizeWatcher = this.domSizeWatcher;
            if (domSizeWatcher != null) {
                domSizeWatcher.clear();
                this.domSizeWatcher = null;
            }
        },
        methods: {
            checkActionPerm: function (action, targetPostId, dataOwnerComId) {
                return checkUserActionPerm(Vue.$getClassInfo(this).path, action, targetPostId, dataOwnerComId);
            },
            getCurrentUserInfo: function () {
                let self = this;
                userApi.getUserInfoByContext({}, function (result, jqXhr) {
                    if (result.type == 'info') {
                        let data = result.data;
                        self.scopeEntity = data.scopeEntity;
                    } else {
                        self.$message.warning(result.message);
                    }
                });
            },
            onQueryConfigReady: function () {
                //
                if (!Utils.isNoB(this.innerNo)) {
                    let query_model_ctrl = this.$refs['query_model_ctrl'];
                    let fieldInfo = {};
                    fieldInfo['innerNo'] = {
                        value: this.innerNo
                    };
                    query_model_ctrl.updateFields(fieldInfo);
                }

                // 纳税类型
                let taxPayTypeList = getEnumList('taxPayType') || [];
                let dataList = [];
                dataList.push({'value': null, 'label': '-全部-'});
                taxPayTypeList.forEach(function (item) {
                    dataList.push({
                        value: item.value,
                        label: item.text
                    });
                });
                this.updateQueryModelField('buyerTaxPayType', dataList);
                this.updateQueryModelField('sellerTaxPayType', dataList);
                // 订单类型
                let orderTypeList = getEnumList('orderType') || [];
                dataList = [];
                dataList.push({'value': null, 'label': '-全部-'});
                orderTypeList.forEach(function (item) {
                    if (item != null && item.name == 'GoodsOrder') {
                        dataList.push({
                            value: item.value,
                            label: item.text
                        });
                    }
                });
                this.updateQueryModelField('orderType', dataList);
                //
                // 生凭状态
                dataList = [];
                dataList = [{'value': null, 'label': '- 全部 -'}];
                let ledgerStateList = getEnumList('ledgerState');
                ledgerStateList.forEach(function (item) {
                    let ledgerState = {};
                    ledgerState.value = item.value;
                    ledgerState.label = item.text;
                    dataList.push(ledgerState);
                });
                let revokeItem = {'value': 100, 'label': '已冲销'};
                dataList.push(revokeItem);
                this.updateQueryModelField('ledgerState', dataList);
            },
            updateQueryModelField: function (itemCode, dataList = []) {
                if (itemCode != null) {
                    let query_model_ctrl = this.$refs['query_model_ctrl'];
                    let data = {dataList: dataList};
                    let fieldInfo = {};
                    fieldInfo[itemCode] = data;
                    query_model_ctrl.updateFields(fieldInfo);
                }
            },
            initResultTable() {
                let self = this;
                let query_model_ctrl = this.$refs['query_model_ctrl'];
                let resultTable = this.$refs['result_table'];
                //关联[查询排序对象]到结果表格（结果表格可以实时利用最新的 列配置 和 排序信息，同时结果表格列宽也会反向同步到其中的[列配置对象]中去）
                resultTable.setQrySortRef(query_model_ctrl);
                //
                resultTable.initMeta(/* confColList, */ /* 单元格html渲染函数 */{
                    // 确认状态
                    'violateStateText': function (row, colName, colValue, rowIndex) {
                        if (Utils.isTrue(row.violated)) {
                            if (row.violateState == 0) {
                                return '<span class=\'font-green\'>违约（已处理）</span>';
                            } else if (row.violateState == 1) {
                                return '<span class=\'font-red\'>违约（未处理）</span>';
                            }
                        } else {
                            return '<span>正常</span>';
                        }
                    },
                    'settleStateX': function (row, colName, colValue, rowIndex, colConf) {
                        return '<span>' + self.settleStateMpas[row.settleState] + '</span>';
                    },
                    'settleProofFlag': function (row, colName, colValue, rowIndex, colConf) {
                        if (row.settleProofId == -1) {
                            return "<span>否</span>";
                        } else {
                            return "<span>是</span>";
                        }
                    },
                    // 生凭状态
                    'ledgerStateX': function (row, colName, colValue, rowIndex) {
                        if (Utils.isTrue(row.fiscalRevoked)) {
                            return '<span class="font-red">已冲销</span>';
                        } else {
                            return '<span>' + self.ledgerStateMap[row.ledgerState] + '</span>';
                        }
                    },
                    'revokerStateX': function (row, colName, colValue, rowIndex, colConf) {
                        if (row.revokerState == 0) {
                            return '<span>待审核</span>';
                        } else if (row.revokerState == 1) {
                            return '<span>审核通过</span>';
                        } else if (row.revokerState == -1) {
                            return '<span>审核未通过</span>';
                        }
                    },
                    'actions': function (row, colName, colValue, rowIndex) {
                        let btnList = [];
                        if (self.checkActionPerm('view_detail')) {
                            btnList.push({
                                name: 'view_detail',
                                text: '详情'
                            });
                        }
                        if (self.checkActionPerm('confirm') && !row.invalid && !row.confirmFlag) {
                            btnList.push({
                                name: 'confirm',
                                text: '确认'
                            });
                        }
                        if (self.checkActionPerm('do_reject', null, row.recvBizUnitId) && !row.pulledBack && !row.invalid && (row.pullBackNo == null || row.pullBackNo == '') && (row.settleProofId == null || row.settleProofId == -1) && row.confirmFlag) {
                            btnList.push({
                                name: 'do_reject',
                                text: '业务冲销'
                            });
                        }
                        if (self.checkActionPerm('do_pulledBack_apply', null, row.recvBizUnitId) && !row.pulledBack && !row.invalid && (row.pullBackNo != null && row.pullBackNo != '' && row.pulledBackApplyState != 1 && row.pulledBackAuditState == 0) && (row.settleProofId == null || row.settleProofId == -1) && row.confirmFlag) {
                            btnList.push({
                                name: 'do_pulledBack_apply',
                                text: '业务冲销申请'
                            });
                        }
                        if (self.checkActionPerm('do_pulledBack_audit', row.pulledBackAuditorPostId, row.recvBizUnitId) && !row.pulledBackOuterAuditFlag && !row.pulledBack && !row.invalid && row.confirmFlag && row.pullBackNo != null && row.pullBackNo != '' && row.pulledBackApplyState == 1 && row.pulledBackAuditState == 0) {
                            btnList.push({
                                name: 'do_pulledBack_audit',
                                text: '业务冲销审核'
                            });
                        }
                        if (self.checkActionPerm('create_js') && row.confirmFlag && row.fiscalConfirmFlag && !row.pulledBack && !row.invalid && row.settleProofId == -1 && row.settleState != -2) {
                            btnList.push({
                                name: 'create_js',
                                text: '结算'
                            });
                        }
                        if (self.checkActionPerm('do_invalid') && !row.invalid && !row.confirmFlag) {
                            btnList.push({
                                name: 'do_invalid',
                                text: '作废'
                            });
                        }
                        if (self.checkActionPerm('do_delete') && row.invalid) {
                            btnList.push({
                                name: 'do_delete',
                                text: '删除'
                            });
                        }
                        return btnList;
                    }
                }, /* 单元格按钮点击处理函数 */{
                    //*代表可处理未指定事件函数的任意列的按钮/链接的点击
                    'actions': function (row, colName, colValue, rowIndex, btnName) {
                        if (!Utils.repeatChecker.isValidFor(btnName, 1000)) {
                            return;
                        }
                        if (btnName == 'view_detail') {
                            self.viewServcWorkReceipt(row);
                        } else if (btnName == 'create_js') {
                            self.toCreateJS(row);
                        } else if (btnName == 'confirm') {
                            self.toConfirm(row);
                        } else if (btnName == 'do_reject') {
                            // 业务冲销
                            self.doRejectServcWorkReceipt(row);
                        } else if (btnName == 'do_pulledBack_apply') {
                            // 业务冲销申请
                            self.doApplyServcWorkReceiptReject(row, null, true);
                        } else if (btnName == 'do_pulledBack_audit') {
                            // 业务冲销审核
                            self.doAuditServcWorkReceiptReject(row);
                        } else if (btnName == 'do_invalid') {
                            // 作废
                            self.doInvalidServcWorkReceipt(row);
                        } else if (btnName == 'do_delete') {
                            // 作废
                            self.doDeleteServcWorkReceipt(row);
                        }
                    }
                });
            },
            //
            queryHandler: function (queryModel) {
                this.queryModel = queryModel;
                this.pageNumber = 1;
                this.getServcWorkReceiptPagedList();
            },
            //
            pageNoChangeHandler: function (pageNumber, pageSize) {
                this.pageSize = pageSize;
                this.pageNumber = pageNumber;
                //
                this.getServcWorkReceiptPagedList();
            },
            renderTable(rows, pagination) {
                //
                let resultTable = this.$refs.result_table;
                //清除数据（如果已经渲染的数据与新的列不是一回事儿）
                //resultTable.clear();
                //同步使用新的自定义列信息
                //resultTable.initMeta(confColList);
                //设置新数据
                let tableData = {
                    rows: rows,
                    pagination: pagination
                };

                resultTable.render(tableData);
            },
            getServcWorkReceiptPagedList() {
                let self = this;
                let postData = {};
                postData.pagination = {
                    pageSize: self.pageSize,
                    pageNumber: self.pageNumber,
                };
                //
                let queryModel = self.queryModel;
                let filterItems = Utils.merge({}, queryModel.filterItems);
                let sortItemList = Utils.merge([], queryModel.sortItemList);
                let sortItems = Utils.merge({}, queryModel.sortItems);
                //
                filterItems.directFlag = getEnumInfoWith('directFlag', 'name', 'Forward').value;
                //
                postData.filterItems = filterItems;
                postData.sortItemList = sortItemList;
                postData.sortItems = sortItems;
                self.exportFilter = Utils.merge({}, filterItems);
                //
                let theLoading = MsgBox.loading();
                receiptApi.getServcWorkReceiptList(postData, function (result) {
                    theLoading.close();
                    if (result.type == 'info') {
                        self.receiptList = result.data.rows;
                        self.totalCount = result.data.pagination.totalCount;
                        self.renderTable(self.receiptList, result.data.pagination);
                    } else {
                        MsgBox.warning(result.message);
                    }
                });
            },
            getTableSelection() {
                let resultTable = this.$refs.result_table;
                return resultTable.getSelection();
            },
            // 查看详情
            viewServcWorkReceipt: function (row) {
                let params = {
                    id: row.id,
                    showViolateBtn: this.checkActionPerm('handle_violate'),
                    createWorkBtn: this.checkActionPerm('create_work')
                };
                openServcWorkReceiptDetailDlg(params);
            },
            // 新增
            toServcWorkReceiptAdd: function () {
                if (!Utils.repeatChecker.isValidFor('toServcWorkReceiptAdd', 1000)) {
                    return;
                }
                let self = this;
                openServcWorkReceiptSaveDlg({}, function (receipt, theDlg) {
                    let theLoad = MsgBox.loading();
                    receiptApi.saveServcWorkReceipt(receipt, function (result) {
                        theLoad.close();
                        if (result.type == 'info') {
                            theDlg.close();
                            MsgBox.success('保存成功');
                            //
                            self.getServcWorkReceiptPagedList();
                        } else {
                            MsgBox.warning(result.message);
                        }
                    });
                });
            },
            // 确认
            toConfirm: function (row) {
                if (!Utils.repeatChecker.isValidFor('toConfirm', 1000)) {
                    return;
                }
                let self = this;
                openServcWorkReceiptConfirmDlg(row.id, function (resultData, theDlg) {
                    let theLoad = MsgBox.loading();
                    receiptApi.doConfirmServcWorkReceipt(resultData, function (result) {
                        theLoad.close();
                        if (result.type == 'info') {
                            theDlg.close();
                            MsgBox.success('操作成功');
                            //
                            self.getServcWorkReceiptPagedList();
                        } else {
                            MsgBox.warning(result.message);
                        }
                    });
                });
            },
            // 业务冲销
            doRejectServcWorkReceipt: function (row) {
                let self = this;
                //
                let postData = {
                    id: row.id
                };
                // 没有对接点或者不选人，指定审核岗
                if (!Utils.isTrue(self.isAuditBpConfAvailable) || !self.needAssignAuditors) {
                    //
                    showComActionPostSelectDlg({
                        title: '工单验收单冲销 - 指定审核岗',
                        rescUrl: Vue.$getClassInfo(this).path,
                        action: 'do_pulledBack_audit',
                        initPostId: row.pulledBackAuditorPostId,
                        useParents: true,
                        descLabel: '冲销原因',
                        applyDesc: row.rejectCause
                    }, function (resultData) {
                        resultData = resultData || {};
                        if (resultData.postId == null) {
                            Toast.show('请选择审核岗位', 3000, 'warning');
                            return false;
                        }
                        //
                        postData.rejectCause = resultData.applyDesc;
                        receiptApi.doPullBackServcWorkReceipt(postData, function (result) {
                            if (result.type == 'info') {
                                // 申请
                                self.doApplyServcWorkReceiptReject(row, resultData.postId, false);
                            } else {
                                MsgBox.warning(result.message);
                            }
                        });
                    }, this);
                } else {
                    // 需要选人，填写冲销原因
                    openApplyDescDlg(function (ruleForm) {
                        let applyDesc = null;
                        if (!Utils.isNoB(ruleForm)) {
                            applyDesc = ruleForm.desc || '';
                        }
                        postData.rejectCause = applyDesc;
                        receiptApi.doPullBackServcWorkReceipt(postData, function (result) {
                            if (result.type == 'info') {
                                // 申请
                                self.doApplyServcWorkReceiptReject(row, null, false);
                            } else {
                                MsgBox.warning(result.message);
                            }
                        });
                    }, '冲销原因');
                }
            },
            // 业务冲销申请
            doApplyServcWorkReceiptReject: function (row, postId, needSelectPost) {
                let self = this;
                if (self.needAssignAuditors && self.isAuditBpConfAvailable) {
                    needSelectPost = false;
                }
                //
                let postData = {
                    id: row.id
                };
                if (Utils.isTrue(needSelectPost)) {
                    showComActionPostSelectDlg({
                        title: '验收单冲销 - 指定审核岗',
                        rescUrl: Vue.$getClassInfo(this).path,
                        action: 'audit',
                        initPostId: row.pulledBackAuditorPostId,
                        useParents: true,
                        descLabel: '冲销原因',
                        applyDesc: row.rejectCause
                    }, function (resultData) {
                        resultData = resultData || {};
                        if (resultData.postId == null) {
                            Toast.show('请选择审核岗位', 3000, 'warning');
                            return false;
                        }
                        //
                        postData.pulledBackAuditorPostId = resultData.postId;
                        postData.rejectCause = resultData.applyDesc;
                        let theLoading = MsgBox.loading();
                        receiptApi.doApplyServcWorkReceiptPullBack(postData, function (resultX) {
                            theLoading.close();
                            if (resultX.type == 'info') {
                                MsgBox.success('操作成功');
                                self.getServcWorkReceiptPagedList();
                            } else {
                                MsgBox.warning(resultX.message);
                            }
                        });
                    }, this);
                } else {
                    //
                    postData.pulledBackAuditorPostId = postId;
                    let theLoading = MsgBox.loading();
                    receiptApi.doApplyServcWorkReceiptPullBack(postData, function (resultX) {
                        theLoading.close();
                        if (resultX.type == 'info') {
                            MsgBox.success('操作成功');
                            self.getServcWorkReceiptPagedList();
                        } else {
                            MsgBox.warning(resultX.message);
                        }
                    });
                }
            },
            // 业务冲销审核
            doAuditServcWorkReceiptReject: function (row) {
                let self = this;
                //
                openAuditDlg(row, function (result) {
                    if (!Utils.isNoB(result)) {
                        let postData = {
                            id: row.id,
                            pullBackNo: row.pullBackNo,
                            auditState: result.resource,
                            auditDesc: result.desc
                        };
                        let theLoading = MsgBox.loading();
                        receiptApi.doAuditServcWorkReceiptPullBack(postData, function (result) {
                            theLoading.close();
                            if (result.type == 'info') {
                                if (row.srcVoucherType == 15) {
                                    MsgBox.success('业务冲销不会产生财务凭据，请根据来源单号，及时进行业务冲销；以便保证资产原值与结算金额一致')
                                } else {
                                    MsgBox.success('操作成功');
                                }
                                self.getServcWorkReceiptPagedList();
                            } else {
                                MsgBox.warning(result.message);
                            }
                        });
                    }
                });
            },
            // 生成结算单
            toCreateJS: function (row) {
                if (!Utils.repeatChecker.isValidFor('toCreateJS', 1000)) {
                    return;
                }
                let self = this;
                let selectList = [];
                if (Utils.isNoB(row)) {
                    selectList = this.getTableSelection();
                } else {
                    selectList.add(row);
                }
                if (selectList == null || selectList.length <= 0) {
                    MsgBox.warning('请选择要操作的数据');
                    return;
                }
                let errMsg = '';
                let contractId = null;
                let buyerRealComCode = null;
                for (let i = 0; i < selectList.length; i++) {
                    let item = selectList[i];
                    if (Utils.isTrue(item.violated) && item.violateState == 1) {
                        errMsg = '【' + item.innerNo + '】违约未处理，不可结算';
                        break;
                    }
                    if (!Utils.isNoB(item.settleProofId) && parseInt(item.settleProofId) > 0) {
                        errMsg = '【' + item.innerNo + '】不可重复结算';
                        break;
                    }
                    if (!Utils.isTrue(item.confirmFlag)) {
                        errMsg = '【' + item.innerNo + '】验收单未确认，不可结算';
                        break;
                    }
                    if (!Utils.isTrue(item.fiscalConfirmFlag)) {
                        errMsg = '【' + item.innerNo + '】验收单财务未确认，不可结算';
                        break;
                    }
                    if (Utils.isTrue(item.invalid)) {
                        errMsg = '【' + item.innerNo + '】验收单作废，不可结算';
                        break;
                    }
                    if (Utils.isNoB(contractId)) {
                        contractId = item.contractId;
                    } else {
                        if (!Utils.isNoB(item.contractId) && item.contractId != contractId) {
                            errMsg = '【' + item.innerNo + '】不可跨合同结算';
                            break;
                        }
                    }
                    if (Utils.isNoB(buyerRealComCode)) {
                        buyerRealComCode = item.buyerRealComCode;
                    } else {
                        if (!Utils.isNoB(item.buyerRealComCode) && item.buyerRealComCode != buyerRealComCode) {
                            errMsg = '【' + item.innerNo + '】不可跨公司结算';
                            break;
                        }
                    }
                }
                if (!Utils.isNoB(errMsg)) {
                    MsgBox.warning(errMsg);
                    return;
                }
                let params = {
                    buyerRealComName: selectList[0].buyerRealComName,
                    sellerRealComName: selectList[0].sellerRealComName,
                    buyerInnerSellerCode: selectList[0].buyerInnerSellerCode,
                    receiptList: selectList
                };
                openServcWorkSettleProofSaveDlg(params, function (settleProof, theDlg) {
                    settleProof.tipFlag = true;
                    let theLoad = MsgBox.loading();
                    settleApi.saveSettleProofByServcWorkVoucher(settleProof, function (saveResult) {
                        theLoad.close();
                        if (saveResult.type == 'info') {
                            theDlg.close();
                            MsgBox.success('提交结算成功');
                            //
                            let resultTable = self.$refs['result_table'];
                            resultTable.setInitChecked([]);
                            //
                            self.getServcWorkReceiptPagedList();
                        } else {
                            if (saveResult.message == '存在部门需要独立核算，将会拆单，是否继续?') {
                                self.$confirm(saveResult.message, '提示', {
                                    confirmButtonText: '确定',
                                    cancelButtonText: '取消',
                                    type: 'warning'
                                }).then(function () {
                                    settleProof.tipFlag = false;
                                    theLoad = MsgBox.loading();
                                    settleApi.saveSettleProofByServcWorkVoucher(settleProof, function (saveResult2) {
                                        theLoad.close();
                                        if (saveResult2.type == 'info') {
                                            theDlg.close();
                                            MsgBox.success('提交结算成功');
                                            //
                                            let resultTable = self.$refs['result_table'];
                                            resultTable.setInitChecked([]);
                                            //
                                            self.getServcWorkReceiptPagedList();
                                        } else {
                                            MsgBox.warning(saveResult2.message);
                                            return false;
                                        }
                                    });
                                }).catch(function () {
                                });
                            } else {
                                MsgBox.warning(saveResult.message);
                                return false;
                            }
                        }
                    });
                });
            },
            // 作废
            doInvalidServcWorkReceipt: function (row) {
                if (!Utils.repeatChecker.isValidFor('doInvalidServcWorkReceipt', 1000)) {
                    return;
                }
                let self = this;
                self.$prompt('请输入作废原因', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                }).then(function (data) {
                    let postData = {
                        id: row.id,
                        invalidCause: data.value
                    };
                    let theLoad = MsgBox.loading();
                    receiptApi.doInvalidServcWorkReceiptById(postData, function (result) {
                        theLoad.close();
                        if (result.type == 'info') {
                            MsgBox.success('操作成功');
                            //
                            self.getServcWorkReceiptPagedList();
                        } else {
                            MsgBox.warning(result.message);
                        }
                    });
                }).catch(function () {
                });
            },
            doDeleteServcWorkReceipt: function (row) {
                if (!Utils.repeatChecker.isValidFor('doDeleteServcWorkReceipt', 1000)) {
                    return;
                }
                let self = this;
                self.$confirm('确定要删除吗', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(function (data) {
                    let postData = {
                        id: row.id
                    };
                    let theLoad = MsgBox.loading();
                    receiptApi.doDeleteServcWorkReceiptById(postData, function (result) {
                        theLoad.close();
                        if (result.type == 'info') {
                            MsgBox.success('操作成功');
                            //
                            self.getServcWorkReceiptPagedList();
                        } else {
                            MsgBox.warning(result.message);
                        }
                    });
                }).catch(function () {
                });
            },
            // 导出
            taskExport: function () {
                if (this.totalCount <= 0) {
                    Toast.show('没有需要导出的数据');
                    return;
                }
                let self = this;
                let resultTable = this.$refs.result_table;
                let tableData = resultTable.getTableData(true);
                delete tableData.rows;//减少数据传输量
                tableData.data = this.getPostData(null);
                tableData.pageSize = 1000;
                tableData.fileRows = 500000;
                let asynTaskInfo = {};
                asynTaskInfo.ownerId = this.scopeEntity.id;
                asynTaskInfo.ownerType = this.scopeEntity.scopeId;
                asynTaskInfo.bizCode = 'gdys.list.export';
                asynTaskInfo.paramInfo = JSON.encode(tableData);
                // 检查唯一键
                let theLoad = MsgBox.loading();
                comnApi.getAsynTaskInfoByUk(asynTaskInfo, function (result) {
                    theLoad.hide();
                    if (result.type == 'info') {
                        let data = result.data;
                        if (data == null) {
                            createTaskExportDlg(asynTaskInfo, function () {
                            });
                        } else {
                            if (data.phase == 3 || data.phase == -1) {
                                self.$confirm('已经创建了相同参数的任务【' + data.title + '】,确定要重新创建吗?', '提示', {
                                    confirmButtonText: '确定',
                                    cancelButtonText: '取消',
                                    type: 'warning'
                                }).then(function () {
                                    createTaskExportDlg(asynTaskInfo, function () {
                                    });
                                }).catch(function () {

                                });
                            } else {
                                MsgBox.warning('已经创建了相同参数的任务【' + data.title + '】且正在进行中,无法重新创建');
                            }
                        }
                    } else {
                        self.$message.warning(result.message);
                    }
                });
            },
            getPostData() {
                let queryModel = this.queryModel;
                let filterItems = Utils.merge({}, this.exportFilter);
                let sortItemList = Utils.merge([], queryModel.sortItemList);
                let sortItems = Utils.merge({}, queryModel.sortItems);
                let multipleSelection = this.getTableSelection();
                if (multipleSelection.length > 0) {
                    let ids = [];
                    multipleSelection.forEach(function (el) {
                        ids.push(el.id);
                    });
                    filterItems.ids = ids;
                }
                //
                let postData = {};
                postData.filterItems = filterItems;
                postData.sortItemList = sortItemList;
                postData.sortItems = sortItems;
                //
                return postData;
            },
            // 查询导出结果
            viewTaskExport: function () {
                let params = {};
                params.ownerId = this.scopeEntity.id;
                params.ownerType = this.scopeEntity.scopeId;
                params.bizCode = 'gdys.list.export';
                viewTaskExportListDlg(params);
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/compo/receipt/ServcWorkReceiptList.vue